import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

const Footer = memo(() => {
  const { t } = useTranslation();
  const currentYear = 2026;

  return (
    <footer className="bg-navy-800 text-white mt-16 border-t border-navy-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Section Informations */}
          <div>
            <h3 className="text-lg font-bold text-gold-400 mb-4">{t('footer.company')}</h3>
            <p className="text-gray-300 text-sm">
              {t('footer.description')}
            </p>
          </div>

          {/* Section Mentions Légales */}
          <div>
            <h3 className="text-lg font-bold text-gold-400 mb-4">{t('footer.legal')}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link 
                  to="/cgv" 
                  className="text-gray-400 hover:text-gold-400 transition-colors"
                >
                  CGV
                </Link>
              </li>
              <li>
                <Link 
                  to="/cgu" 
                  className="text-gray-400 hover:text-gold-400 transition-colors"
                >
                  CGU
                </Link>
              </li>
              <li>
                <Link 
                  to="/politique-confidentialite" 
                  className="text-gray-400 hover:text-gold-400 transition-colors"
                >
                  Politique de Confidentialité
                </Link>
              </li>
            </ul>
          </div>

          {/* Section Contact & Copyright */}
          <div>
            <h3 className="text-lg font-bold text-gold-400 mb-4">{t('footer.contact')}</h3>
            <p className="text-gray-300 text-sm mb-4">
              {t('footer.contactDescription')}
            </p>
          </div>
        </div>

        {/* Ligne de séparation */}
        <div className="border-t border-navy-700 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-gray-400 text-sm">
              {t('footer.copyright', { year: currentYear })}
            </div>

            {/* Crédit développeur */}
            <div className="text-gray-400 text-sm">
              {t('footer.developer')}{' '}
              <a 
                href="https://creatif-web.eu" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gold-400 hover:text-gold-300 font-semibold transition-colors underline"
              >
                {t('footer.developerLink')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
});

Footer.displayName = 'Footer';

export default Footer;
